import { setMessage } from 'apps/notifications/actions/notifications';
import { wa } from 'apps/analytics';

import { linksWithQuery } from '[theme-lib]/links';

import {
  BOOK_SLOT_PROMPT_DISPLAYED_DESC,
  BOOK_SLOT_PROMPT_CONFIRMED_DESC,
} from '../consts';

export function showBookASlotMessage(message) {
  return (dispatch) => {
    dispatch(setMessage(message));
  };
}

export function redirectToSlotBooking() {
  return (dispatch, getState, { network }) => {
    const redirect = () => {
      network.redirectTo({ to: linksWithQuery.BOOK_DELIVERY({ fromBookSlotPrompt: true }) });
    };
    wa.triggerPageEventWithDescription(
      BOOK_SLOT_PROMPT_CONFIRMED_DESC,
      /* fields= */ null,
      redirect
    );
  };
}

export function reportDisplayToWA() {
  return () => {
    wa.triggerPageEventWithDescription(BOOK_SLOT_PROMPT_DISPLAYED_DESC);
  };
}
